import React from "react";

const getHighlightedText = (text = "", highlight = "") => {
    // Split text on highlight term, include term itself into parts, ignore case
    const parts = text?.split(new RegExp(`(${highlight})`, "gi"));
    return <span>{parts.map(part => part.toLowerCase() === highlight?.toLowerCase() ? <span style={{fontWeight: "600"}}>{part}</span> : part)}</span>;
};

export default getHighlightedText;
